import {validateColorAndPerformCastingIfNecessary} from '../../../privates/validations/styleValidation';
import styleService from './styleService';
import * as members from '../../../privates/privateMembers';
import StyleProperties from '../../../privates/styleConstants';

class BorderColorMixin {

  /**
   * @member borderColor
   * @memberof $w.Style
   * @param {external:String} borderColor
   */
    set borderColor(borderColor) {
        const compName = members._compName.get(this);
        const opacitySupport = true;

        const validColor = validateColorAndPerformCastingIfNecessary(borderColor, opacitySupport, StyleProperties.BORDER_COLOR, compName);
        if (!validColor){
            return;
        }
        styleService.setStyle.call(this, StyleProperties.BORDER_COLOR, validColor);
    }

    /**
     * @member borderColor
     * @label property
     * @syntax
     * get borderColor(): string
     * set borderColor(rgbaColor: string): void
     * @summary Sets or gets the border color of an element.
     * @description
     *  The border color value is a string representing an rgba color in one of
     *  the following formats:
     *
     *  + `"red"`: One of [140 predefined color names](https://www.w3schools.com/colors/colors_names.asp).
     *  + `"#FF0000"`: A hexidecimal rgb color value.
     *  + `"rgb(255,0,0)"`: An rgb() function color value.
     *  + `"#FF000000"`: A hexidecimal rgba color value.
     *  + `"rgba(255,0,0,1.0)"`: An rgba() function color value.
     *
     * This style can be used with the following elements:
     *
     *  + [`Box`]($w.Box.html)
     *  + [`Button`]($w.Button.html)
     *  + [`Checkbox`]($w.Checkbox.html)
     *  + [`CheckboxGroup`]($w.CheckboxGroup.html)
     *  + [`Dropdown`]($w.Dropdown.html)
     *  + [`Footer`]($w.Footer.html)
     *  + [`Header`]($w.Header.html)
     *  + [`ProgressBar`]($w.ProgressBar.html)
     *  + [`RadioButtonGroup`]($w.RadioButtonGroup.html)
     *  + [`TextBox`]($w.TextBox.html)
     *  + [`TextInput`]($w.TextInput.html)
     *  + [`UploadButton`]($w.UploadButton.html)
     *
     * @snippet [BorderMixin-borderColor_set.es6=Set the border color]
     * @snippet [BorderMixin-borderColor_get.es6=Get the border color]
     * @type {external:String}
     * @memberof $w.Style
     * @instance
     */
    get borderColor() {
        return styleService.getStyleParamValue.call(this, StyleProperties.BORDER_COLOR);
    }

}

export default BorderColorMixin;
